import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { PROD } from '../../common/constants';
import { Card, Container, Grid, Button, Stack, CardContent, Typography} from '@mui/material';
import { useNavigate } from "react-router-dom";
import { ProceedIcon } from '../../common/icons';
function ResourceDashboard() {
  const navigate = useNavigate()
  function proceedFunction(type) {
    if(type === "sent") {
      navigate("sentForApproval")
    }
    else if(type === "actionTaken") {
      navigate("actionTaken")
    }
    else {
      navigate("allWorkList")
    }
  }
  return (
    <>
      <Helmet>
        <title> Home | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
        Manage Worklist
        </Typography>
        <Grid container spacing={3}>       
        <Grid item xs={12} lg={6}>
                  <Card style={{ borderRadius: 10 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}}>
                        Sent for Approval
                        </Typography>
                        <Button endIcon={<ProceedIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                          size="medium"
                          variant="contained"
                          onClick={() => proceedFunction("sent")}
                          >Proceed</Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Card style={{ borderRadius: 10 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}} >
                        All Worklist
                        </Typography>
                        <Button endIcon={<ProceedIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                          size="medium"
                          variant="contained"
                          onClick={() => proceedFunction("all")}
                          >Proceed</Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
                <Grid item xs={12} lg={6}>
                  <Card style={{ borderRadius: 10 }}>
                    <CardContent>
                      <Stack spacing={1}>
                        <Typography variant="h5" sx={{ mb: 2 , fontWeight:'bold', fontSize:'4vh'}} >
                        Action Taken
                        </Typography>
                        <Button endIcon={<ProceedIcon />} sx={{ padding: '5px 10px', alignSelf: 'flex-end' }}
                          size="medium"
                          variant="contained"
                          onClick={() => proceedFunction("actionTaken")}
                          >Proceed</Button>
                      </Stack>
                    </CardContent>
                  </Card>
                </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default ResourceDashboard